<!--
* @Name：采购订单页面
* @Author: 刘玉
* @Date: 2021-12-02 10:47:19
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 10:47:19
-->
<template>
  <div class="approval-container">
    <van-nav-bar title="采购订单审批" left-arrow left-text="返回" @click-left="onClickLeft" :fixed="true" />
    <van-collapse class="approval-info" v-model="activeNames">
      <van-collapse-item name="baseInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">采购订单基本信息</span>
        </template>
        <base-info :head-info="headInfo" />
      </van-collapse-item>
      <van-collapse-item name="attachment">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">附件信息</span>
        </template>
        <hi-attachment :attach-list="attachList"></hi-attachment>
      </van-collapse-item>
      <van-collapse-item name="materialDetails">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">物料信息明细</span>
        </template>
        <material-details :currencyDict="headInfo.currencyDict" todo-name="PoApproval" />
      </van-collapse-item>
      <van-collapse-item name="paymentPlan">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">付款计划</span>
        </template>
        <payment-plan :paln-list="palnList" todo-name="PoApproval" />
      </van-collapse-item>
      <van-collapse-item name="approvalOpinions">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">审批意见</span>
        </template>
        <hi-flow-approval />
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { coopPoCreateHead, selectPlan } from '@/api/purchaseOrder'
import { slectHeadInfo } from '../../api/purchaseOrder'
import Bridge from '@/components/dsbridge'
export default {
  name: 'PoApproval',
  components: {
    'base-info': () => import('./components/BaseInfo.vue'),
    'material-details': () => import('./components/MaterialDetails.vue'),
    'payment-plan': () => import('./components/PaymentPlan.vue')
  },
  data() {
    return {
      activeNames: ['baseInfo', 'approvalOpinions'],
      headInfo: {},
      attachList: [],
      detailsInfo: [],
      palnList: [],
      // poCreateHeadId: this.$store.getters.businessKey
      poCreateHeadId: this.$route.query.businessKey
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    async initData() {
      const headResp = await coopPoCreateHead(this.poCreateHeadId)
      const headResp1 = await slectHeadInfo(this.poCreateHeadId)
      // console.log(headResp1)
      this.headInfo = headResp.data
      this.attachList = headResp1.data.uploadFile
      console.log(123, this.attachList)
      // const planResp = await selectPlan(this.$store.getters.businessKey)
      const planResp = await selectPlan(this.$route.query.businessKey)
      this.palnList = planResp.data
    },
    onClickLeft() {
      // this.$router.push('/todo')
      Bridge.callMethodSyn('app.jsLeavePage', '')
    }
  }
}
</script>
<style lang="scss" scoped>
.title-class {
  background-color: #eee;
}
</style>
